import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@carrier-io/air-react/Box";
import { AdminHeader } from "../components/admin/AdminHeader";
import { AdminBar } from "../components/admin/AdminBar";

export const AdminLayout = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "grid",
        gridTemplateColumns: "56px 1fr",
        gridTemplateRows: "auto 1fr",
        gridTemplateAreas: `
                "header header"
                "nav main"
            `,
      }}
    >
      <AdminHeader />
      <AdminBar />
      <Box
        component="main"
        sx={{
          gridArea: "main",
        }}
      >
        {/* @ts-expect-error - Known issue with Outlet types */}
        <Outlet />
      </Box>
    </Box>
  );
};
